import { render, staticRenderFns } from "./ListInitialRecommendation.vue?vue&type=template&id=a31e38be&scoped=true&"
import script from "./ListInitialRecommendation.vue?vue&type=script&lang=js&"
export * from "./ListInitialRecommendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31e38be",
  null
  
)

export default component.exports